module.exports = "<div class=\"wrapper wrapper-content animated fadeInRight help-shell\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/help/help.shell.component.html
// module id = 1149
// module chunks = 0